import styled from "styled-components";
import { Flex } from "../Box";

/**
 * Shared frame for the loading / error / empty states. The three must stay visually distinct
 * (brief addendum §5): loading = quiet skeleton surface, error = danger ring + retry,
 * empty = plain surface with copy (+ optional character).
 */
export const StateFrame = styled(Flex)<{ $tone?: "default" | "danger" | "warning" }>`
  flex-direction: column;
  align-items: center;
  justify-content: center;
  text-align: center;
  width: 100%;
  padding: 24px 16px;
  border-radius: ${({ theme }) => theme.radii.card};
  background: ${({ theme }) => theme.colors.backgroundAlt};
  border: 1px solid ${({ theme }) => theme.colors.cardBorder};
  box-shadow: ${({ theme, $tone }) =>
    $tone === "danger" ? theme.shadows.danger : $tone === "warning" ? theme.shadows.warning : theme.shadows.deep};

  ${({ theme }) => theme.mediaQueries.sm} {
    padding: 32px 24px;
  }
`;

export const StateIllustration = styled.img`
  width: 96px;
  height: 96px;
  object-fit: contain;
  margin-bottom: 12px;
  user-select: none;
  pointer-events: none;

  ${({ theme }) => theme.mediaQueries.sm} {
    width: 128px;
    height: 128px;
  }
`;
